import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import { typography, colors, mq } from 'src/styles';
import { InputStyles, InputWrap, setInputTheme } from 'src/components/Input';
import { ButtonStyles } from 'src/components/Button';

const MarketoForm = styled.form`
	&.mktoForm {
		width: 100% !important;
		font-family: ${typography.primaryFont} !important;
		color: inherit !important;
		padding: 0 !important;
    ${mq.largeAndUp} {
    	display: flex;
	    flex-wrap: wrap;
  		margin-right: -20px;
  		width: calc(100% + 20px) !important;
  	}
    .mktoFormRow {
    	${mq.largeAndUp} {
    		width: calc(50% - 20px);
    		margin-right: 20px;
    	}
    }
		.mktoOffset,
		.mktoGutter {
			display: none !important;
		}
		.mktoFormCol {
			float: none;
			margin-bottom: 20px !important;
		}
		.mktoFieldWrap {
			float: none;
			${InputWrap}
			${ ({ inputStyle }) => inputStyle ? 
				setInputTheme(inputStyle.toLowerCase())
			: 
				setInputTheme('white')
			}
			display: flex;
			flex-direction: column;
			width: 100% !important;
		}
		.mktoLabel {
			float: none;
			${typography.bodyTiny}
			font-weight: ${typography.medium} !important;
			color: ${colors.lightTextColor};
			padding-left: 14px;
			display: flex;
			width: 100% !important;
			align-items: baseline;
			justify-content: flex-start;
			order: 2;
			margin: .3em 0 0;
			.mktoAsterix {
				color: ${colors.red};
				float: none !important;
				display: inline;
				// padding: 0;
				order: 2;
			}
		}
		.mktoButtonRow {
			width: 100%;
			span {
				margin: 0 !important;
				button {
					margin-top: 20px;
					${ButtonStyles(false, false, 'medium', 'default')}
					${typography.body}
					font-weight: ${typography.bold} !important;
					font-size: 16px !important;
					line-height: 1em !important;
					background-image: none !important;
					background: ${colors.mainColor} !important;
					border-color: ${colors.mainColor} !important;
					padding: 0 1.5em 2px !important;
					&:hover,
					&:focus,
					&:active {
						background: ${colors.lightGrey} !important;
						border-color: ${colors.lightGrey} !important;
						color: ${colors.mainColor} !important;
					}
				}
			}
		}
		input,
		select {
			${typography.body}
			font-size: 16px !important;
			${mq.mediumAndBelow} {
				font-size: 14px !important;
			}
			width: 100% !important;
			${InputStyles(false, 'medium', false, 'left', 'default', false)}
			padding-left: 14px !important;
			padding-right: 14px !important;
			height: 48px !important;
		}
	}
`;

const Marketo = ({
	node
}) => {
	const [scriptLoaded, setScriptLoaded] = useState(false);
	const [scriptWaitCount, setScriptWaitCount] = useState(1);
	const timer = useRef(null);

	const waitOnMktoForms2 = () => {
		if (window.MktoForms2) {
			setScriptLoaded(true);
		} else if (scriptWaitCount > 10) {
			console.error('Could not load form!');
		} else {
			timer.current = setTimeout(() => {
				waitOnMktoForms2();
			}, 40 * scriptWaitCount);
			setScriptWaitCount(scriptWaitCount + 1);
		}
	}

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const script = document.createElement("script");
			script.src = node.script;
			script.async = true;
			script.onload = waitOnMktoForms2;

			document.body.appendChild(script);
		}
		return () => {
			if (!!timer.current) {
				clearTimeout(timer.current);
			}
		}
	}, []);

	useEffect(() => {
		if (scriptLoaded && window?.MktoForms2) {
			window.MktoForms2.loadForm(node.baseUrl, node.munchkinId, node.formId);
			const formElement = document.getElementById(`mktoForm_${node.formId}`);
			formElement.style = false;
		}
	}, [scriptLoaded]);

	return <MarketoForm id={`mktoForm_${node.formId}`} inputStyle={node.inputStyle}></MarketoForm>;
};

export default Marketo;